// extracted by mini-css-extract-plugin
module.exports = {"changePwd":"ChangePassword_changePwd_3WIJ0","closePage":"ChangePassword_closePage_EDuo2","inputWrap":"ChangePassword_inputWrap_1lwYg","submit":"ChangePassword_submit_1hy9k"};